/**
 * Urgency flag
 * tag: 61
 * @readonly
 * @enum {string} (char)
 */
export enum Urgency {
  /** Normal */
  Normal = '0',
  /** Flash */
  Flash = '1',
  /** Background */
  Background = '2',
}
